import {onFind} from "@elements/init-modules-in-scope";
import {removeClass,addClass,on,findIn, findAllIn, hasClass} from '@elements/dom-utils';

const selectors = {
    base: '.js-number-format',
    value: '.js-number-format__value',
};

export function init() {
    onFind(selectors.base, function (baseElement) {
        let value = findIn(selectors.value, baseElement);
        let regExp = /^0/;

        if(value.value < 10 && !regExp.test(value.value)){
            value.value = "0" + value.value;
        }

        on("change", function(){
            if(value.value < 10){
            value.value = "0" + value.value;
            }
        }, baseElement)
    });
}
